import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'

import VueRouter from 'vue-router'
import vco from 'v-click-outside'
import router from './router/index'
import Api from './services/api'
import Commafy from './utils/Commafy'
import ConvertToEnglish from './utils/ConvertToEnglish'
import store from '@/state/store'
import App from './App.vue'
import i18n from './i18n'
import getColors from './utils/getColors'
import convertDate from './utils/convertDate'
import '../src/design/app.scss'
import '../src/design/custom/plugins/icons/_fontawesome-all.scss'

Vue.use(VueRouter)
Vue.use(vco)
Vue.mixin(Commafy)
Vue.mixin(ConvertToEnglish)
Vue.mixin(convertDate)
Vue.config.productionTip = false
Vue.mixin(getColors)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)

Vue.component('apexchart', VueApexCharts)
Api.init()
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
